import React from "react";

export const AccessForbidden = () => (
  <div className="">
    <h2>Доступ к разделу отсуствует</h2>
  </div>
);
